<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">{{isEditing() ? 'Редактирование категории' : 'Создание категории'}}</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Название</label>
          <input type="text" class="form-control" v-model="category.name">

          <label class="mt-3">Промежуток</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="input-from">От</span>
          </div>
          <input  aria-describedby="input-from" type="number" class="form-control" v-model="category.from">
          <div class="input-group-append">
            <span class="input-group-text">руб.</span>
          </div>
          <div class="input-group-prepend ml-3">
            <span class="input-group-text">До</span>
          </div>
          <input type="number" class="form-control" v-model="category.to">
          <div class="input-group-append">
            <span class="input-group-text">руб.</span>
          </div>
        </div>

          <label class="mt-3">Цвет</label>
          <div class="btn-toolbar">
            <div class="input-group mr-3">
            <input type="text" class="form-control" v-model="category.color">
            </div>
        <div class="btn-group">
          <div @click="editColor(category.color)" data-toggle="dropdown" class="color-preview" :style="'background-color: ' + (category.color ? category.color : '#ac2925') + '!important;'"></div>
          <div class="dropdown-menu">
            <compact-picker :value="category.color" @input="onColorInput"></compact-picker>
          </div>
        </div>
          </div>
        </div>

      </div>

      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          @click="saveCategory"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import {Compact} from 'vue-color'
  import api from '@/api'

  export default {
    components: {
      'compact-picker': Compact
    },
    props: ['categoryData', 'machineType'],
    data () {
      return {
        category: this.categoryData ? Object.assign({}, this.categoryData) : {color: '#000000'},
      }
    },
    methods: {
      saveCategory () {
        const data = {
          name: this.category.name,
          color: this.category.color,
          from: this.category.from,
          to: this.category.to,
          type: this.machineType,
        }
        if (this.isEditing()) {
          return api.put('categories/' + this.categoryData.id, data).then(({data}) => {this.hide(data)})
        } else {
          return api.post('categories', data).then(({data}) => {this.hide(data)})
        }
      },
      hide (data) {
        this.$emit('hide', data)
      },
      onColorInput (value) {
        this.category.color = value.hex
      },
      editColor (color) {},
      isEditing () {
        return !!this.categoryData
      }
    }
  }
</script>
<style lang="scss">
  .color-preview {
    width: 50px;
    height: 100%;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/category-modal.vue